module.exports = __webpack_public_path__ + "396ba9db19913c1e6f0187af2a86a743.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_l_70.mp3
// module id = 444
// module chunks = 0